import './App.css';
import {HomePage} from "./pages/home/home_page";
import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
import {DetectionPage} from "./pages/detection/detection_page";
import DetectionProvider from "./core/state/detection/detection_context";
import {DETECT_PAGE, HOME_PAGE} from "./config/router/router";

function App() {
    return (
        <Router>
            <DetectionProvider>
                <Switch>
                    <Route path={HOME_PAGE} exact={true} component={HomePage}/>
                    <Route path={DETECT_PAGE} exact={true} component={DetectionPage}/>
                </Switch>
            </DetectionProvider>
        </Router>
    );
}

export default App;
